export default __webpack_public_path__ + "static/media/symbol-16.8da0ba4b.svg";